import { render } from "./UAppLayout.vue?vue&type=template&id=4a7f995d&scoped=true"
import script from "./UAppLayout.vue?vue&type=script&lang=ts"
export * from "./UAppLayout.vue?vue&type=script&lang=ts"

import "./UAppLayout.vue?vue&type=style&index=0&id=4a7f995d&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-4a7f995d"

export default script